var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Layer_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 64 64",
  style: {
    "enableBackground": "new 0 0 64 64"
  },
  xmlSpace: "preserve"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M48,0H16C9.4,0,4,5.4,4,12v40.2c0,3,2.4,4.8,4.8,4.8c1.5,0,2.9-0.7,3.9-2.1l1.3-1.9c0.9-1.4,2.5-2.1,4-2.1 s3,0.7,4,2.1l6.1,9c1,1.4,2.5,2.1,4,2.1s3-0.7,4-2.1l6-9c1-1.4,2.5-2.1,4-2.1s3,0.7,4,2.1l1.3,1.9c1,1.5,2.5,2.1,3.9,2.1 c2.4,0,4.8-1.8,4.8-4.8V12C60,5.4,54.6,0,48,0z M41.5,33.5h-19c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h19c0.8,0,1.5,0.7,1.5,1.5 S42.3,33.5,41.5,33.5z M49,25.5H15c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h34c0.8,0,1.5,0.7,1.5,1.5S49.8,25.5,49,25.5z M49,17.5 H15c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h34c0.8,0,1.5,0.7,1.5,1.5S49.8,17.5,49,17.5z"
})));
export default __webpack_public_path__ + "static/media/wallet_icons-06.859a7f2f.svg";
export { SvgComponent as ReactComponent };